<template>
  <div :class="[$blockClass(blockClass, 'navigation-group')]">
    <div
      class="text-label-s"
      :class="[$blockClass(blockClass, 'navigation-title')]"
      v-if="title"
    >
      {{ title }}
    </div>
    <ul :class="[$blockClass(blockClass, 'navigation-list')]">
      <li
        v-for="(tier1) in menu.items"
        :class="[$blockClass(blockClass, 'navigation-item')]"
        :key="tier1.handle"
      >
        <a
          class="text-body-s"
          :href="tier1.url"
          v-text="tier1.title"
        />
      </li>
    </ul>
  </div>
</template>

<script>

/**
 * Vue: Site Footer Nav (site-footer-nav)
 * -----------------------------------------------------------------------------
 * Global interactive button element.
 * - Styles are imported in critical styles.
 * - Must be imported as <btn> as <button> is a default element.
 *
 * @param {String} [blockClass] - Block level class to apply to all elements.
 * @param {Object} [menus] - Group of menu lists
 * @param {String} title - Menu title
 *
 */

export default {
  name: 'SiteFooterNav',

  props: {
    blockClass: {
      type: String,
      default: '',
    },

    menu: {
      type: Object,
      default: () => ({}),
    },

    title: {
      type: String,
      default: '',
    }
  },
}
</script>
